import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)

// Service worker registration is wrapped by the PWAUpdatePrompt component
// inside the app, so update lifecycle and UI stay co-located.
